export const getClassName = (s) => {
    if (s != null) {
        return s.replace(/[^\w]/gi, "_").toLowerCase();
    }

    return '';
};

export const announceForScreenReader = (s) => {
    document.getElementById('screen_reader_announce').innerHTML = s;
    return true;
};

export const trimSpaces = (s) => {
    return s.replace(/(?:^[\s\u00a0]+)|(?:[\s\u00a0]+$)/g, '');
};

